import { Button, Card, CardContent } from '@crm/ui';
import { ChevronDown, ChevronUp, Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ONBOARDING_ROUTES, useDismissOnboarding, useOnboarding } from '../api';
import { OnboardingTimeline } from './onboarding-timeline';

/**
 * O guia no topo do painel. Fechado mostra so o passo atual, em uma linha -
 * a lista inteira ali em cima empurraria os atalhos para debaixo da dobra.
 */
export function OnboardingCard() {
  const progresso = useOnboarding();
  const dispensar = useDismissOnboarding();
  const [aberto, setAberto] = useState(false);

  const dados = progresso.data;
  if (!dados) return null;

  const pendentes = dados.steps.filter((step) => !step.done);
  const atual = pendentes[0];

  // Tudo pronto, ou o salao ja dispensou e nada regrediu: o guia sai da tela.
  if (!atual) return null;
  if (dados.dismissedAt) return null;

  const porcentagem = Math.round((dados.completed / dados.total) * 100);

  return (
    <Card>
      <CardContent className="space-y-3 py-3.5">
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <Sparkles className="h-4 w-4 shrink-0 text-primary" />
              <h2 className="text-sm font-medium">Assistente de Configuração do Sistema</h2>
              <span className="text-xs text-muted-foreground">
                {dados.completed}/{dados.total}
              </span>
            </div>
            <div className="mt-1.5 h-1.5 rounded-full bg-muted">
              <div className="h-1.5 rounded-full bg-primary" style={{ width: `${porcentagem}%` }} />
            </div>
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={() => setAberto((valor) => !valor)}
            aria-expanded={aberto}
          >
            {aberto ? 'Ver menos' : 'Ver mais'}
            {aberto ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
          </Button>

          <Button
            size="icon"
            variant="ghost"
            aria-label="Dispensar guia de configuracao"
            onClick={() => dispensar.mutate()}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        {aberto ? (
          <div className="border-t border-border pt-3">
            <OnboardingTimeline steps={pendentes} compact />
            <div className="flex justify-end">
              <Button variant="ghost" size="sm" asChild>
                <Link to={ONBOARDING_ROUTES.PROGRESS}>Abrir o assistente</Link>
              </Button>
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-sm">
              <span className="font-medium">{atual.title}</span>
              <span className="ml-1.5 text-muted-foreground">{atual.hint}</span>
            </p>
            <Button size="sm" asChild>
              <Link to={ONBOARDING_ROUTES.PROGRESS}>Configurar</Link>
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
